module.exports = __webpack_public_path__ + "static/media/blind_man_2.43e1b3c6.png";